var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.moduleLoading,"empty":_setup.isEmpty}},[(_setup.initialized)?_c('div',{staticClass:"finance-chart"},[_c('m-line-bar',{attrs:{"seriesData":_setup.chartData,"chartOptions":_setup.chartOptions}})],1):_vm._e(),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }